export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'c1c5757d-93d5-41e4-b7d4-fa2d67bc714a';
export const MODAL_CLOSE_SEC = 2.5;
export const ANIMATION_WAIT = 1;
